<template>
  <div>
    <div class="form-top">
      <h1>委托我的房屋</h1>
      <p v-if="active=='0'">提示：该房源信息提交后，将由石柱生活网负责房源维护、拟售客源的管理。您点击提交委托后，即视为您同意委托石柱生活网为您的拟售房源提供服务。</p>
      <p v-if="active=='1'">提示：填写自己的购房意向，石柱生活网房小柒会根据您购买的意向，选择合适的二手房房源给您推荐；</p>
    </div>
    <van-tabs v-model="active" type="card">
      <van-tab title="我要卖房">
        <div class="form">
          <div class="form-box">
            <div class="form-box-t">选择小区</div>
            <div class="form-box-c">
              <marea :lists="configs.area" @change="getXiaoqu" />
            </div>
          </div>

 

          <div class="form-box">
            <div class="form-box-t">户型</div>
            <div class="form-box-c">
              <huxingpicker
                @change="getHuxing"
                :lists="[configs['shi'],configs['ting'],configs['wei']]"
              ></huxingpicker>
            </div>
          </div>

          <van-row :gutter="15">
            <van-col :span="12">
              <div class="form-box">
                <div class="form-box-t">面积</div>
                <div class="form-box-c">
                  <div class="form-box-tag">
                    <div class="form-input-flex">
                      <input type="number" class="form-input" v-model="sellhouse.mianji" />
                      <div class="unit">m²</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-col>
            <van-col :span="12">
              <div class="form-box">
                <div class="form-box-t">期望{{txt}}(0为面议)</div>
                <div class="form-box-c">
                  <div class="form-box-tag">
                    <div class="form-input-flex">
                      <input type="number" class="form-input" v-model="sellhouse.price" />
                      <div class="unit">{{sellhouse.unit}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </van-col>
          </van-row>

          <div class="form-box">
            <div class="form-box-t">联系人</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-float">
                  <input type="text" v-model="sellhouse.contact" />
                </div>
              </div>
            </div>
          </div>

          <div class="form-box">
            <div class="form-box-t">联系电话</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-float">
                  <input type="number" v-model="sellhouse.phone" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-box">
            <div class="form-box-t">备注</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-float">
                  <textarea
                    v-model="sellhouse.content"
                    rows="4"
                    placeholder="详细的描述房屋状况，可以帮你快速的出售房源（5-2000个字符）"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top:10px">
            <img src="../../assets/images/liucheng.png" width="100%" />
          </div>
          <div class="form-box">
            <div class="form-box-t">
              <van-button type="info" block @click="postSell">保存</van-button>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="我要买房">
        <div class="form">
          <div class="form-box">
            <div class="form-box-t">您的买房预算：</div>
            <div class="form-box-c">
              <div class="yusuan">
                <h1>20-{{buyhouse.price}}万</h1>
                <van-slider
                  v-model="buyhouse.price"
                  :min="20"
                  :step="5"
                  :max="500"
                  bar-height="4px"
                  active-color="#1989fa"
                ></van-slider>
              </div>
            </div>
          </div>
          <div class="form-box">
            <div class="form-box-t">购买偏好</div>
            <div class="form-box-c">
              <formtag :lists="['新房','二手房','不限']" @change="getPianhao"></formtag>
            </div>
          </div>
          <div class="form-box">
            <div class="form-box-t">购买户型</div>
            <div class="form-box-c">
              <formtag :lists="['1居','2居','3居','4居','5居','5居+']" @change="getbuyHuxing"></formtag>
            </div>
          </div>

          <div class="form-box">
            <div class="form-box-t">意向小区</div>
            <div class="form-box-c">
              <mparea :lists="configs.area" @change="getbuyXiaoqu" />
            </div>
          </div>

          <div class="form-box">
            <div class="form-box-t">其它要求？</div>
            <div class="form-box-c">
              <van-checkbox-group v-model="buyhouse.peitao">
                <van-checkbox v-for="(item, index) in peitao" :key="index" :name="item">{{ item }}</van-checkbox>
              </van-checkbox-group>
            </div>
          </div>
          <div class="form-box">
            <div class="form-box-t">联系人</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-float">
                  <input type="text" v-model="buyhouse.contact" />
                </div>
              </div>
            </div>
          </div>

          <div class="form-box">
            <div class="form-box-t">联系电话</div>
            <div class="form-box-c">
              <div class="form-box-tag">
                <div class="form-input-float">
                  <input type="number" v-model="buyhouse.phone" />
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top:10px">
            <img src="../../assets/images/liucheng.png" width="100%" />
          </div>
          <div class="form-box">
            <div class="form-box-t">
              <van-button type="info" block @click="postBuy">保存</van-button>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>

    <footbar></footbar>
  </div>
</template>

<script>
var root = process.env.VUE_APP_API_URL;
import Formtag from "../commpents/tag";
import Huxingpicker from "../commpents/huxingpicker";
import Footbar from "../commpents/footbar";
import District from "../commpents/district";
import Loucengpicker from "../commpents/loucengpicker";
import Tencentmap from "../commpents/tencentmap";
import Marea from "../commpents/marea";
import Mparea from "../commpents/mparea";
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Toast,
  Cell,
  CellGroup,
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Row,
  Col,
  Tag,
  Dialog,
  Slider,
  Tab,
  Tabs
} from "vant";

export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [CheckboxGroup.name]: CheckboxGroup,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [Dialog.Component.name]: Dialog.Component,
    [Slider.name]: Slider,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    Formtag,
    Huxingpicker,
    Loucengpicker,
    Footbar,
    District,
    Tencentmap,
    Marea,
    Mparea
  },

  data() {
    return {
      getInitUrl: root + "post/init",
      getBuyUrl: root + "post/buyhouse",
      getSellUrl: root + "post/sellhouse",
      active: "0",
      isactive: false,
      configs: [],
      id: 0,
      txt: "售价",
      peitao: [
        "优质学区",
        "交通便利",
        "生活便利",
        "南北通透",
        "车位充足",
        "高楼层",
        "中间楼层",
        "绿化率高",
        "带电梯",
        "优质物业",
        "不要顶层",
        "不要底层"
      ],
      buyhouse: {
        agent: 0,
        price: 35,
        huxing: "",
        pianhao: "",
        xingzhi: "我要买房",
        phone: "",
        contact: "",
        content: "",
        unit: "万元",
        community: ""
      },
      sellhouse: {
        agent: 0,
        price: "",
        huxing: [],
        mianji: "",
        xingzhi: "我要卖房",
        map: {},
        phone: "",
        contact: "",
        content: "",
        unit: "万元",
        community: []
      }
    };
  },

  mounted() {
    if (JSON.stringify(this.$route.params) == "{}") {
    } else {
      this.formItem.agent = this.$route.params.id;
    }
    window.scrollTo(0, 0);
    this.init();
  },

  methods: {
    init() {
      var self = this;
      $.ajax({
        url: self.getInitUrl,
        timeout: 120000,
        dataType: "json",
        type: "get",
        data: {},
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.configs = reponseData.configs;
          self.sellhouse.phone = reponseData.mobile;
          self.sellhouse.contact = reponseData.name;

          self.buyhouse.phone = reponseData.mobile;
          self.buyhouse.contact = reponseData.name;

          if (reponseData.islogin == 0) {
            self.$router.push("/login");
          }
        },
        error: function() {
          self.$toast("system error");
        }
      });
    },
    getXiaoqu(value) {
      this.sellhouse.community = value;
    },
    getbuyXiaoqu(value) {
      this.buyhouse.community = value;
    },
    getArea(value) {
      this.sellhouse.area = value;
    },
    getPianhao(value) {
      this.buyhouse.pianhao = value;
    },
    getHuxing(value) {
      this.sellhouse.huxing = value;
    },
    getbuyHuxing(value) {
      this.buyhouse.huxing = value;
    },
    getLouceng(value) {
      this.formItem.louceng = value;
    },
    getZhuangxiu(value) {
      this.formItem.zhuangxiu = value;
    },
    getXingzhi(value) {
      this.formItem.xingzhi = value;
      if (value == "我要卖房") {
        this.formItem.unit = "万元";
        this.txt = "售价";
      }
      if (value == "我要买房") {
        this.formItem.unit = "万元";
        this.txt = "售价";
      }
    },
    getChaoxiang(value) {
      this.formItem.chaoxiang = value;
    },
    getMap(value) {
      this.sellhouse.map = value;
    },
    postBuy() {
      var self = this;
      if (this.isactive) {
        this.$toast("已经提交");
        return;
      }
      var self = this;
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: "数据提交中"
      });
      self.isactive = true;
      console.log(self.buyhouse);
      $.ajax({
        url: self.getBuyUrl,
        timeout: 120000,
        dataType: "json",
        type: "post",
        data: self.buyhouse,
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast.clear();

          if (reponseData.status == 1) {
            //发布成功
            // 进行下一步操作
            //self.$router.push("/user/house");
            Dialog.alert({
              title: "提示信息",
              message: "提交委托成功，石柱生活网房小二会在第一时间和您取得联系；"
            }).then(() => {
              self.$router.push("/");
            });
          } else {
            self.isactive = false;
            self.$toast(reponseData.message);
          }
        },
        error: function() {
          self.isactive = false;
          self.$toast("system error");
        }
      });
    },
    postSell() {
      var self = this;
      if (this.isactive) {
        this.$toast("已经提交");
        return;
      }
      var self = this;
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: "数据提交中"
      });
      self.isactive = true;
      $.ajax({
        url: self.getSellUrl,
        timeout: 120000,
        dataType: "json",
        type: "post",
        data: self.sellhouse,
        headers: self.getRequestHeader(),
        success: function(reponseData, status) {
          self.$toast.clear();

          if (reponseData.status == 1) {
            //发布成功
            // 进行下一步操作
            //self.$router.push("/user/house");
            Dialog.alert({
              title: "提示信息",
              message: "提交委托成功，石柱生活网房小二会在第一时间和您取得联系；"
            }).then(() => {
              self.$router.push("/");
            });
          } else {
            self.isactive = false;
            self.$toast(reponseData.message);
          }
        },
        error: function() {
          self.isactive = false;
          self.$toast("system error");
        }
      });
    }
  }
};
</script>

<style scoped>
.form-top {
  background-color: #f8f8f8;
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
}
.form-top h1 {
  font-size: 16px;
  margin-top: 15px;
}
.form-top p {
  color: #888;
  line-height: 18px;
  font-size: 14px;
  padding: 15px;
}
.yusuan h1 {
  margin: 0 0 15px 0;
  text-align: center;
  padding: 0;
  font-size: 24px;
  font-weight: normal;
  color: #1989fa;
}
.van-checkbox-group {
  display: flex;
  flex-flow: wrap;
}
.van-checkbox {
  width: 33.3333333333%;
  margin: 5px 0;
}
</style>>



